
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/nettbutikk/[categorySlug]/[slug]",
      function () {
        return require("private-next-pages/nettbutikk/[categorySlug]/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/nettbutikk/[categorySlug]/[slug]"])
      });
    }
  